//FUNCIONS
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../store/createStore';
// import GoogleMapReact from 'google-map-react';

//HOOKS
import { useTranslation } from '../../../hooks/useTranslation';

//COMPONENTS

//STYLES
import {
  Container,
  ContainerTitle,
  ContainerAddressRowHeader,
  ContainerPaymentLeft,
  ContainerDefaultPayCard,
  CardNumber,
  CardName,
  CardContainerSplit,
  ContainerPaymentRight,
  ContainerPaymentData,
  ContainerDataRequest,
  ContainerDataRequestItem,
  ContainerMap,
  // DivSpace,
  ContainerPayments,
  ResumeContainer,
  ContainerProducts,
} from './styles';
import { useCheckoutFunction } from '../../../hooks/useCheckoutFunctions';
import Loading from '../../../components/Loading';
import { ProductConferenre } from '../NChkProductsList/ProductConference';
import { config } from '../../../config';
import { useCheckoutInfo } from '../../../hooks/useCheckoutInfo';
import { RoundHelper } from '../../../utils/roundHelper';

const ViewConference: React.FC = () => {
  const { checkout, loading, methodPaymentSelected, shipping } = useSelector(
    (state: StoreState) => state.checkout,
  );
  const { store, locker, address, method, payOnDelivery } = useSelector(
    (state: StoreState) => state.parameter,
  );
  const { user } = useSelector((state: StoreState) => state.auth);
  const { onTranslation: t } = useTranslation();
  const { handlerGetCheckout } = useCheckoutFunction();
  const {
    addressSelected,
  } = useCheckoutInfo();
  //  const handleApiLoaded = useCallback((map, maps) => {
  //    //konsole.log(map, maps)

  //  }, [])

  useEffect(() => {
    handlerGetCheckout();
  }, [handlerGetCheckout]);

  return (
    <>
      <Container>
        {loading ? (
          <Loading size={160} bShowText />
        ) : (
          <>
            <ContainerTitle>
              <h3>{t('main.new_checkout.view_conference.order_check')}</h3>
            </ContainerTitle>

            <ContainerPayments>
              <ContainerPaymentLeft>
                <ContainerAddressRowHeader>
                  <h3>
                    {t('main.new_checkout.view_conference.delivery_address')}
                  </h3>
                  {address && (
                    <span>
                      {address.address},{address.number} -{' '}
                      {address.neighborhood} - {address.city} - {address.state}{' '}
                      - CEP: {address.postcode}
                    </span>
                  )}
                  {store && (
                    <span>
                      {store.address},{store.number} - {store.neighborhood} -{' '}
                      {store.city} - {store.state} - CEP: {store.zip_code}
                    </span>
                  )}
                  {locker && (
                    <span>
                      {locker.address},{locker.number} - {locker.neighborhood} -{' '}
                      {locker.city} - {locker.state} - CEP: {locker.zip_code}
                    </span>
                  )}
                </ContainerAddressRowHeader>
                <ResumeContainer>
                  <h3>
                    Resumo da compra
                  </h3>
                  <ContainerProducts>
                    {checkout.items &&
                    Object.values(checkout.items).filter(itemFilter => itemFilter.is_available === undefined || itemFilter.is_available > 0).map(item => (
                      <ProductConferenre key={item.id} product={item} />
                    )
                    )}
                  </ContainerProducts>
                </ResumeContainer>
                <ContainerMap>
                  {/* <h3 style={{ color: 'red' }}>MAPA FAKE AINDA EM DESENVOLVIMENTO</h3> */}
                  {/* <MapWrapped
                    googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyAmBOfVu8GtaYY0V99Q34ZbCVxO_woae_k`}
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: `100%` }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                  /> */}
                  {/* <DivSpace>
                      <GoogleMapReact
                        bootstrapURLKeys={{
                          key: 'AIzaSyAmBOfVu8GtaYY0V99Q34ZbCVxO_woae_k',
                        }}
                        yesIWantToUseGoogleMapApiInternals
                        defaultCenter={location.center}
                        defaultZoom={location.zoom}

                      // onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
                      >
                        <AnyReactComponent
                          lat={location.center.lat}
                          lng={location.center.lng}
                          text="MAPA FAKE"
                        />
                      </GoogleMapReact>
                    </DivSpace> */}
                </ContainerMap>
              </ContainerPaymentLeft>

              <ContainerPaymentRight>
                <ContainerPaymentData>
                  <ContainerDataRequest>
                    <ContainerDataRequestItem>
                      <h4>
                        {t('main.new_checkout.view_conference.order_summary')}
                      </h4>
                    </ContainerDataRequestItem>
                    <ContainerDataRequestItem>
                      <span>
                        {t('main.new_checkout.view_conference.subtotal')}
                      </span>
                      <span>
                        {checkout && RoundHelper.toFormatted(checkout.grand_total)}
                      </span>
                    </ContainerDataRequestItem>
                    <ContainerDataRequestItem>
                      <span>
                        {t('main.new_checkout.view_conference.shipping')}
                      </span>
                      {shipping > 0 ? RoundHelper.toFormatted(shipping) : 'Grátis'}
                    </ContainerDataRequestItem>
                    {Number(checkout.discount) > 0 && (
                      <ContainerDataRequestItem>
                        <span>
                          {t('main.new_checkout.view_conference.discount')}
                        </span>
                        {RoundHelper.toFormatted(checkout.discount)}
                      </ContainerDataRequestItem>
                    )}
                    <ContainerDataRequestItem>
                      <span>
                        {t('main.new_checkout.view_conference.total')}
                      </span>
                      <span>
                        {RoundHelper.toFormatted(RoundHelper.toNumber(checkout.grand_total) + shipping)}
                      </span>
                    </ContainerDataRequestItem>
                  </ContainerDataRequest>
                </ContainerPaymentData>
                {
                  !config.isNewLayoutChosePayment && (
                    <>
                      {payOnDelivery ? (
                        <>
                          <ContainerPaymentData>
                            <ContainerDataRequest>
                              <ContainerDataRequestItem>
                                <h4>
                                  {t(
                                    'main.new_checkout.view_conference.data_payment',
                                  )}
                                </h4>
                              </ContainerDataRequestItem>
                              <ContainerDataRequestItem>
                                <ContainerDefaultPayCard>
                                  <CardNumber>
                                    <h3>
                                      {t(
                                        'main.component_account_payment.pay_on_delivery',
                                      )}
                                    </h3>
                                  </CardNumber>
                                </ContainerDefaultPayCard>
                              </ContainerDataRequestItem>
                            </ContainerDataRequest>
                          </ContainerPaymentData>
                        </>
                      ) : (
                        <>
                          {user.data.seller !== 1 && (
                            <ContainerPaymentData>
                              <ContainerDataRequest>
                                <ContainerDataRequestItem>
                                  <h4>
                                    {t(
                                      'main.new_checkout.view_conference.data_payment',
                                    )}
                                  </h4>
                                </ContainerDataRequestItem>

                                <ContainerDataRequestItem>
                                  {method && (
                                    <ContainerDefaultPayCard>
                                      <CardNumber>
                                        <span>
                                          {'****.****.****.' + method.card_last_four}
                                        </span>
                                      </CardNumber>
                                      <CardName>
                                        <span>{method.full_name}</span>
                                      </CardName>
                                    </ContainerDefaultPayCard>
                                  )}
                                </ContainerDataRequestItem>
                                <ContainerDataRequestItem>
                                  <CardContainerSplit>
                                    <span>
                                      1x parcela {RoundHelper.toFormatted(
                                      address &&
                                        address.shipping &&
                                        address.shipping.price
                                        ? (
                                          RoundHelper.toNumber(checkout.grand_total) +
                                          address.shipping.price
                                        ).toFixed(2)
                                        : RoundHelper.toNumber(checkout.grand_total).toFixed(2))}
                                    </span>
                                  </CardContainerSplit>
                                </ContainerDataRequestItem>
                              </ContainerDataRequest>
                            </ContainerPaymentData>
                          )}
                        </>
                      )}
                    </>
                  )
                }
                {
                  config.isNewLayoutChosePayment && (
                    <ContainerPaymentData>
                      <ContainerDataRequest>
                        <ContainerDataRequestItem>
                          <h4>
                            {t(
                              'main.new_checkout.view_conference.data_payment',
                            )}
                          </h4>
                        </ContainerDataRequestItem>

                        <ContainerDataRequestItem>
                          {
                            methodPaymentSelected.cards.length > 0 && (
                              <ContainerDefaultPayCard>
                                <CardNumber>
                                  <span>{'****.****.****.' + methodPaymentSelected.cards[0].card_last_four}</span>
                                </CardNumber>
                                <CardName><span>{methodPaymentSelected.cards[0].full_name}</span></CardName>
                              </ContainerDefaultPayCard>
                            )
                          }
                          {
                            methodPaymentSelected.others.length > 0 && (
                              <ContainerDefaultPayCard>
                                <CardNumber>
                                  <span>{methodPaymentSelected.others[0].name}</span>
                                </CardNumber>
                              </ContainerDefaultPayCard>
                            )
                          }
                          {
                            methodPaymentSelected.cashOnDelivery.length > 0 && (
                              <ContainerDefaultPayCard>
                                {
                                    addressSelected.type === "addressUser" ? (
                                      <>
                                        <span>{'Pagamento na entrega: ' + methodPaymentSelected.cashOnDelivery[0].name}</span>
                                      </>
                                    ) : (
                                      <span>{'Pagamento na retirada: ' + methodPaymentSelected.cashOnDelivery[0].name}</span>
                                    )
                                }
                              </ContainerDefaultPayCard>
                            )
                          }
                        </ContainerDataRequestItem>
                        {
                          methodPaymentSelected.cards.length > 0 && (
                            <ContainerDataRequestItem>
                              <CardContainerSplit>
                                <span>
                                  1x parcela {RoundHelper.toFormatted(
                                  address &&
                                    address.shipping &&
                                    address.shipping.price
                                    ? (
                                      RoundHelper.toNumber(checkout.grand_total) +
                                      address.shipping.price
                                    ).toFixed(2)
                                    : RoundHelper.toNumber(checkout.grand_total).toFixed(2))}
                                </span>
                              </CardContainerSplit>
                            </ContainerDataRequestItem>
                          )
                        }
                      </ContainerDataRequest>
                    </ContainerPaymentData>
                  )
                }
              </ContainerPaymentRight>
            </ContainerPayments>
          </>
        )}
      </Container>
    </>
  );
};

export default ViewConference;
